export const GTAG_ID = "UA-187900465-1";

export const loadScripts = (): Promise<void> => {
  return new Promise(resolve => {
    if (!document.getElementById("analyticsblock")) {
      const script2 = document.createElement("script");
      script2.id = "analyticsblock";
      script2.innerHTML = `
    (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
      (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
      m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
      })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
      
      ga('create', '${GTAG_ID}', 'auto');
      ga('set', 'anonymizeIp', true);
      ga('send', 'pageview');`;

      document.head.appendChild(script2);
    }
    resolve();
  });
};

export const pageview = (url: string): void => {
  if (!(window as any).ga) {
    return;
  }

  (window as any).ga("send", "pageview");
};

export const event = ({
  action,
  category = undefined,
  label = undefined,
  value = undefined,
}: {
  action: string;
  category?: string;
  label?: string;
  value?: string;
}): void => {
  if (!(window as any).ga) {
    return;
  }

  (window as any).ga("send", "event", action, category, label, value);
};
